import * as types from './../constants/articleHeaderActionTypes';

function articleHeader(state = {}, action) {
  switch (action.type) {
    case types.ARTICLE_HEADER_LOAD_REQUEST:
      return {...state, isLoading: true};

    case types.ARTICLE_HEADER_LOAD_SUCCESS:
      return {...state, isLoading: false, ...action.articleHeader};

    case types.ARTICLE_HEADER_LOAD_FAILURE:
      return {...state, isLoading: false, error: action.error};

    default:
      return state;
  }
}

export default articleHeader;
